import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { LangService } from 'src/app/core/services/lang.service';
import { CommonService } from '../../../services/common.service';
import { fixedValues } from 'src/app/shared/constants/fixed-values.enum';
import { GridService } from 'src/app/shared/services/grid.service';

@Component({
  selector: 'app-accounts-list-with-path',
  templateUrl: './../../../templates/forms/modals/account-list-with-path.component.html',
})
export class AccountsListWithPathComponent implements OnInit {
  @Input()
  config: any;

  @Input()
  accountsListModalExtarnalValue;

  @Input()
  modalShow: boolean = true;

  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  dataObj: any;
  columnDefs = [];
  colObj;
  grid: any;
  gridId: string = "AccountsListWithPathGrid";
  chartOfAccountList: any[] = [];
  searchFields: any[] = ['ACC_NAME', 'ACC_NO'];
  public searchString;

  constructor(public langService: LangService,
     private dataService: CommonService,
     public gridService: GridService) {
      this.colObj = [ 
        { headerName: langService.langData.accountName,  field: 'ACC_NAME', sortable: true, resizable: true, hide: false },
        { headerName: langService.langData.accCode, field: 'ACC_CODE', sortable: true, filter: true, resizable: true, hide: false },
        { headerName: langService.langData.accPath, field: 'ACC_PATH', sortable: true, filter: true, resizable: true, hide: false },
      ];
   }

  ngOnInit() {
    this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId);

  }


  onGridReady(grid) {
    this.grid = grid;
    this.gridService.sizeColumnsToFit(grid, this.gridId);
    if (this.accountsListModalExtarnalValue) {
      this.dataService.getChartOfAccounts(this.accountsListModalExtarnalValue)
        .subscribe(arg => {
          this.chartOfAccountList = arg.body
        });
    }
    else {
      this.dataService.getChartOfAccounts(fixedValues.queryOptions.CoaForCSOB)
        .subscribe(arg => { this.chartOfAccountList = arg.body });
    }
  }
  itemClick(_item) {
    this.modalShow = false;
    this.dataObj = _item;
    this.submit.next();
  }
}
